import { createSelector } from 'reselect';
import { ISkillState } from './types';

const selectSkills = (state: { skills: ISkillState }) => state.skills;

export const selectSkillsLoading = createSelector(
  selectSkills,
  (skills) => skills.loading
);

export const selectSkillsData = createSelector(
  selectSkills,
  (skills) => skills.data
);

export const selectSkillsError = createSelector(
  selectSkills,
  (skills) => skills.error
);